export default Object.freeze({
  ITEMS_PER_PAGE: 20,
  INITIAL_START_INDEX: 0,
  INITIAL_END_INDEX: 19,
  INITIAL_END_INDEX_VIEW_ALL: 19,
});
